<template>
    <div
        v-if="isShowModal"
        :style="componentStyles"
        class="o-services-modal-otg-3"
        @click.self="closeModal"
    >
        <OOtgModalContainer
            :headerLabel="currentItemName"
            @onClose="closeModal"
        >
            <div class="services-modal-otg-3-inner-container">
                <OServicesModalSidebarOtg
                    :items="preparedItems"
                    :header-label="headerLabel"
                    class="services-modal-otg-3-sidebar"
                    @onServiceClick="onServiceClick"
                />
                <OModalItemDetails3
                    :item="currentService"
                    :item-name="currentItemName"
                    class="item-details"
                    @onClose="closeModal"
                />
            </div>
        </OOtgModalContainer>
    </div>
</template>

<script>
import sortBy from 'lodash/sortBy';
import { mapGetters } from 'vuex';

import OOtgModalContainer from '../../organisms/o-otg-modal-container';
import OModalItemDetails3 from '../../organisms/o-modal-item-details-3';
import OServicesModalSidebarOtg from '../../unique-organisms/o-services-modal-sidebar-otg';

import { EVENTS } from '../../../utils/constants/bus-events-constants';

export default {
    name: 'OServicesModalOtg3',
    components: {
        OOtgModalContainer,
        OModalItemDetails3,
        OServicesModalSidebarOtg
    },
    data() {
        return {
            config: null,
            isShowModal: false,
            currentItemIndex: 0
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getListItem',
            'getActiveLocale',
            'getMapConfigProp',
            'getObjectsByCategory'
        ]),
        items() {
            return sortBy(this.getObjectsByCategory(this.config.itemId), ["distance"]) || {};
        },
        currentItem() {
            return this.getListItem(this.config.itemId) || '';
        },
        currentItemName() {
            return this.t(this.currentItem, 'name') || '';
        },
        preparedItems() {
            return this.items
                .filter(i => i.distance)
                .map((el, index) => {
                    const icon = this.t(el, 'icon');
                    const name = this.t(el, 'name');
                    const altText = this.$t('services-modal-tile-icon');
                    const cssClass = index === this.currentItemIndex ? 'services-modal-tile-active' : null;
                    const distance = this.t(el, 'distance');
                    const distanceIcon = index === this.currentItemIndex ? 'guide-path-white' : 'icons/guide-path-red';
                    const distanceText = `${this.t(el, 'distance')} ${this.$t('ui.meter')}`;

                    return {
                        ...el,
                        icon,
                        name,
                        altText,
                        cssClass,
                        distance,
                        distanceIcon,
                        distanceText
                    }
                }) || [];
        },
        currentService() {
            return this.preparedItems[this.currentItemIndex];
        },
        currentServiceId() {
            return this.currentService?.id;
        },
        componentStyles() {
            return this.getMapConfigProp('components.OServicesModalOtg3.styles') || null;
        },
        componentParams() {
            return this.getMapConfigProp('components.OServicesModalOtg3.params') || {};
        },
        headerLabel() {
            if(this.componentParams.is_show_custom_header_label) {
                if(!this.t(this.currentItem, 'customJSON')) {
                    return this.$t('ui.select-service', { service: this.currentItemName }) || '';
                }

                const customData = JSON.parse(this.t(this.currentItem, 'customJSON'));
                const customName = customData.custom_modal_names[`name_${this.getActiveLocale}`];

                return this.$t('ui.select-service', { service: customName });
            }

            return this.$t('ui.select-service', { service: this.currentItemName }) || '';
        }
    },
    mounted() {
        this.initListeners();
    },
    beforeDestroy() {
        this.removeListeners();
    },
    methods: {
        initListeners() {
            this.$bus.$on(EVENTS.MODALS.OFF_MODAL, this.closeModal);
            this.$bus.$on(EVENTS.MODALS.INIT_SERVICES_MODAL, this.initModal);
        },
        removeListeners() {
            this.$bus.$off(EVENTS.MODALS.OFF_MODAL, this.closeModal);
            this.$bus.$off(EVENTS.MODALS.INIT_SERVICES_MODAL, this.initModal);
        },
        initModal(data) {
            this.isShowModal = true;
            this.config = data;
        },
        closeModal() {
            this.isShowModal = false;
            this.currentItemIndex = 0;
        },
        onServiceClick(index) {
            this.currentItemIndex = index;
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />